var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "intelligent-booking-result-container" },
    [
      _c(
        "div",
        { staticClass: "main-content-area" },
        [
          _c(
            "cargo-left-right-resize",
            {
              staticClass: "content-resize-container",
              attrs: {
                "left-style": { "min-width": "550px", width: "50%" },
                "right-style": { "min-width": "550px", width: "50%" }
              }
            },
            [
              _c("template", { slot: "left" }, [
                _c(
                  "div",
                  { staticClass: "left-panel" },
                  [
                    _c("image-preview-cwmi", {
                      ref: "imagePreviewCwmi",
                      attrs: {
                        "image-info": _vm.resultArray[_vm.pageNum - 1].pointer,
                        "cur-focus": _vm.curFocus
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("template", { slot: "right" }, [
                _c("div", { staticClass: "right-panel" }, [
                  _vm.details.identificationType === _vm.SENDING_2.code
                    ? _c(
                        "div",
                        { staticClass: "toggle-mode-container" },
                        [
                          _c("span", { staticClass: "toggle-label" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "CargoMsg.Cargo_DisplayDifferenceInformation"
                                )
                              )
                            )
                          ]),
                          _c("el-switch", {
                            attrs: {
                              "active-color": "#1890ff",
                              "inactive-color": "#dcdfe6"
                            },
                            on: { change: _vm.handleToggleChange },
                            model: {
                              value: _vm.showDifferenceOnly,
                              callback: function($$v) {
                                _vm.showDifferenceOnly = $$v
                              },
                              expression: "showDifferenceOnly"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "form-content-area" }, [
                    _vm.details.identificationType === _vm.SENDING_0.code
                      ? _c(
                          "div",
                          { staticClass: "form-container" },
                          [
                            _c("result-form-se", {
                              ref: "resultForm",
                              attrs: {
                                details: _vm.details,
                                "result-array": _vm.resultArray,
                                index: _vm.pageNum - 1,
                                source: _vm.source
                              },
                              on: {
                                fieldFocus: function(val) {
                                  _vm.curFocus = val
                                  _vm.$refs.imagePreviewCwmi.curFocusChange(val)
                                  _vm.resultArray[
                                    _vm.pageNum - 1
                                  ].curFocus = val
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.details.identificationType === _vm.SENDING_4.code
                      ? _c(
                          "div",
                          { staticClass: "form-container" },
                          [
                            _c("result-form-ae", {
                              ref: "resultForm",
                              attrs: {
                                details: _vm.details,
                                "result-array": _vm.resultArray,
                                index: _vm.pageNum - 1,
                                source: _vm.source
                              },
                              on: {
                                fieldFocus: function(val) {
                                  _vm.curFocus = val
                                  _vm.$refs.imagePreviewCwmi.curFocusChange(val)
                                  _vm.resultArray[
                                    _vm.pageNum - 1
                                  ].curFocus = val
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.details.identificationType === _vm.SENDING_5.code
                      ? _c(
                          "div",
                          { staticClass: "form-container" },
                          [
                            _c("result-form-ai", {
                              ref: "resultForm",
                              attrs: {
                                details: _vm.details,
                                "result-array": _vm.resultArray,
                                index: _vm.pageNum - 1,
                                source: _vm.source
                              },
                              on: {
                                fieldFocus: function(val) {
                                  _vm.curFocus = val
                                  _vm.$refs.imagePreviewCwmi.curFocusChange(val)
                                  _vm.resultArray[
                                    _vm.pageNum - 1
                                  ].curFocus = val
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.details.identificationType === _vm.SENDING_2.code
                      ? _c(
                          "div",
                          { staticClass: "form-container" },
                          [
                            _c("result-form-se-td", {
                              ref: "resultForm",
                              attrs: {
                                details: _vm.details,
                                "result-array": _vm.resultArray,
                                index: _vm.pageNum - 1,
                                source: _vm.source,
                                "show-all": _vm.showAll
                              },
                              on: {
                                fieldFocus: function(val) {
                                  _vm.curFocus = val
                                  _vm.$refs.imagePreviewCwmi.curFocusChange(val)
                                  _vm.resultArray[
                                    _vm.pageNum - 1
                                  ].curFocus = val
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ])
              ])
            ],
            2
          )
        ],
        1
      ),
      _c("div", { staticClass: "bottom-area" }, [
        _c(
          "div",
          { staticClass: "pagination-container" },
          [
            _c("el-pagination", {
              attrs: {
                background: "",
                "current-page": _vm.pageNum,
                "pager-count": 5,
                "page-size": 1,
                layout: "prev, pager, next, jumper",
                total: _vm.total
              },
              on: {
                "update:currentPage": function($event) {
                  _vm.pageNum = $event
                },
                "update:current-page": function($event) {
                  _vm.pageNum = $event
                }
              }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "bottom-buttons" },
          [
            _vm.details.status === 3
              ? [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "1", type: "primary" },
                      on: { click: _vm.handleClose }
                    },
                    [_vm._v(_vm._s(_vm.$t("Message.Close")))]
                  )
                ]
              : [
                  _vm.SENDING_0.code,
                  _vm.SENDING_4.code,
                  _vm.SENDING_5.code
                ].indexOf(_vm.details.identificationType) > -1
              ? [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "2", type: "success" },
                      on: { click: _vm.handleSave }
                    },
                    [_vm._v(_vm._s(_vm.$t("Payment.save")))]
                  ),
                  _c(
                    "el-button",
                    { attrs: { no: "4" }, on: { click: _vm.refresh } },
                    [_vm._v(_vm._s(_vm.$t("Message.Close")))]
                  )
                ]
              : _vm.details.identificationType === _vm.SENDING_2.code
              ? [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "4", type: "primary" },
                      on: { click: _vm.overrideSystemBillHandler }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.$t("CargoMsg.Cargo_OverrideSystemBillOfLading")
                        )
                      )
                    ]
                  ),
                  _c(
                    "el-button",
                    { attrs: { no: "4" }, on: { click: _vm.refresh } },
                    [_vm._v(_vm._s(_vm.$t("Message.Close")))]
                  )
                ]
              : _vm._e()
          ],
          2
        )
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            no: "saveAndBookingDialog",
            visible: _vm.saveAndBookingDialog.visible,
            title: _vm.$t("Message.WarmReminder"),
            width: "630px",
            "append-to-body": "",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.saveAndBookingDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "20px 40px 20px 40px" } },
            [
              _vm._l(_vm.saveAndBookingDialog.data, function(item, index) {
                return _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.jobList.length === 0,
                        expression: "jobList.length === 0"
                      }
                    ],
                    key: index
                  },
                  [
                    _c("div", {
                      domProps: {
                        innerHTML: _vm._s(index + 1 + "." + item + "</br></br>")
                      }
                    })
                  ]
                )
              }),
              _c("cargo-ag-grid", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.jobList.length > 0,
                    expression: "jobList.length > 0"
                  }
                ],
                staticStyle: { height: "200px" },
                attrs: {
                  "config-module": "3300012",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.gridOptions.columnDefs,
                  "row-data": _vm.jobList || []
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridOptions.gridApi = params.api
                  }
                }
              })
            ],
            2
          ),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.saveAndBookingDialogClose }
                },
                [_vm._v(_vm._s(_vm.$t("Message.GotIt")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.jobList.length > 0,
                      expression: "jobList.length > 0"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.exportTemplateHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Print")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.jobList.length > 0,
                      expression: "jobList.length > 0"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.copyHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_UpdateBusinessAgain")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            no: "creditValidDialog",
            visible: _vm.creditValidDialog.visible,
            title: _vm.$t("Message.WarmReminder"),
            width: "630px",
            "append-to-body": "",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.creditValidDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { padding: "20px 40px 20px 40px" } },
            _vm._l(_vm.creditValidDialog.data, function(item, index) {
              return _c("div", { key: index }, [
                _c("div", [
                  _vm._v(
                    " " + _vm._s(_vm.$t("CargoMsg.Cargo_Book") + item[0]) + " "
                  )
                ]),
                _c("div", {
                  staticStyle: { "margin-left": "20px" },
                  domProps: { innerHTML: _vm._s(item[1]) }
                })
              ])
            }),
            0
          ),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      _vm.creditValidDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.GotIt")))]
              )
            ],
            1
          )
        ]
      ),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "batch-create-job": true,
              "append-to-body": true,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2,
              "close-callback": _vm.batchCheckingWindow.closeCallback
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("cargo-template-selector-dialog", {
        ref: "templateSelectorDialog",
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          lob: _vm.lob,
          context: this,
          "print-channel": 1,
          "pre-print-callback": _vm.templateSelectorDialog.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }